<div class='application-details'>
  <div class='row'>
    <div class='col-md-4'>
      <app-label label='Data utworzenia:'>
        {{ application()?.createdAt | date }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Data zatwierdzenia:'>
        {{ application()?.updatedAt | date }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Numer sprawy:'>
        {{ application()?.caseNumber || '-' }}
      </app-label>
    </div>
  </div>
  <br>
  <div class="doc-preview">
    <iframe
      referrerpolicy="strict-origin-when-cross-origin"
      [src]="(env.apiBasePath + '/application/' + application()?.uuid + '/html') | safeContent: 'resourceUrl'">
    </iframe>
  </div>
  <br>
  <br>
  <h3>
    Załączniki
  </h3>
  <app-attachments-data-preview [application]='application()'>
  </app-attachments-data-preview>
</div>
